import { render } from "./RtfDialog.vue?vue&type=template&id=3d7fe3ee&scoped=true"
import script from "./RtfDialog.vue?vue&type=script&lang=js"
export * from "./RtfDialog.vue?vue&type=script&lang=js"

import "./RtfDialog.vue?vue&type=style&index=0&id=3d7fe3ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7fe3ee"]])

export default __exports__